import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoHeartDislikeOutline, IoShareOutline } from "react-icons/io5";
import { useFavorites } from "../context/FavoritesContext";
import { IoTrashOutline } from "react-icons/io5";
import { useCart } from "../context/CartContext";
import { useNotification } from "../context/NotificationContext";
import { useCurrency } from "../context/CurrencyContext";
import { getSessionId } from "../utils/SessionId"; 

function Favorites() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  const { fetchFavoritesIds } = useFavorites();
  const { updateCartCount } = useCart();
  const { showNotification } = useNotification();
  const { formatPrice } = useCurrency();

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const res = await axios.get(
        `https://blomengdalis-tester.com/backend/get_favorites.php?session_id=${getSessionId()}`
      );
      setFavorites(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setFavorites([]);
    } finally {
      setLoading(false);
    }
  };

  const removeFavorite = async (id) => {
    try {
      await axios.post(
        "https://blomengdalis-tester.com/backend/toggle_favorite.php",
        {
          session_id: getSessionId(), 
          product_id: id,
          action: "remove",
        }
      );

      showNotification("تم حذف المنتج من المفضلة", "success");
      fetchFavorites();
      fetchFavoritesIds();
    } catch (err) {
      console.error(err);
      showNotification("حدث خطأ أثناء الحذف", "error");
    }
  };

  const addToCart = async (product) => {
    const sessionId = getSessionId(); 

    try {
      const response = await axios.post(
        "https://blomengdalis-tester.com/backend/add_to_cart.php",
        {
          session_id: sessionId,
          product_id: product.id,
          quantity: 1,
          size: product.sizes || "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      showNotification("تم إضافة المنتج للسلة", "success");
      updateCartCount();
    } catch (error) {
      console.error(error);
      showNotification("فشل في إضافة المنتج إلى السلة", "error");
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: "قائمة الأمنيات",
        url: window.location.href,
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      showNotification("تم نسخ الرابط", "success");
    }
  };

  if (loading) return <div className="p-10 text-center">جاري التحميل...</div>;

  return (
    <div className="max-w-[95%] mx-auto">
      <div className="flex gap-2 text-sm text-gray-500 mt-5">
        <Link to="/" className="text-black">
          الصفحة الرئيسية
        </Link>
        <span>/</span>
        <span className="text-gray-400">قائمة الأمنيات</span>
      </div>

      <h2 className="text-xl font-medium mt-3">
        قائمة الأمنيات ({favorites.length})
      </h2>

      {favorites.length > 0 && (
        <div className="flex justify-end gap-3 my-6">
          <button
            onClick={handleShare}
            className="flex items-center gap-2 border px-4 py-2 text-sm hover:bg-gray-100"
          >
            <IoShareOutline size={18} />
            شارك قائمتك
          </button>
        </div>
      )}

      {favorites.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 text-center">
          <div className="mb-6">
            <IoHeartDislikeOutline size={70} className="text-gray-300" />
          </div>

          <h3 className="text-xl font-medium mb-3">هذه القائمة فارغة.</h3>

          <p className="text-gray-500 max-w-md leading-relaxed mb-8">
            ما عليك سوى الضغط على الرمز ♡ الموجود بجانب منتجاتنا لحفظ المنتجات
            التي تحبينها لوقت لاحق.
          </p>

          <Link
            to="/"
            className=" border border-black px-10 py-3 text-black text-bold
                 hover:bg-black hover:!text-white "
          >
            تسوق أحدث ما وصلنا
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-6">
          {favorites.map((product) => {
            const hasDiscount =
              product.discount_percent &&
              parseFloat(product.discount_percent) > 0;

            const displayPrice = hasDiscount
              ? product.price_after
              : product.original_price;

            return (
              <div key={product.id} className="pb-6 md:pb-0 relative">
                <div className="flex gap-4 md:flex-col ">
                  <Link
                    to={`/product/${product.id}`}
                    className="w-[110px] h-[160px] md:w-full md:h-[400px] flex-shrink-0"
                  >
                    <img
                      src={`https://blomengdalis-tester.com/backend/uploads/${product.main_image}`}
                      alt={product.name}
                      className="w-full h-full object-cover bg-card"
                    />
                  </Link>

                  <div className="flex-1 md:p-4">
                    <Link
                      to={`/product/${product.id}`}
                      className="block text-black text-sm md:text-base font-medium mb-1"
                    >
                      {product.name}
                    </Link>
                    <p className="text-xs md:text-sm text-gray-500 mb-1">
                      {product.description}
                    </p>
                    {hasDiscount ? (
                      <div className="flex items-center gap-2 mb-3">
                        <span className="text-sm font-semibold">
                          {formatPrice(parseFloat(product.price_after))}
                        </span>
                        <span className="text-xs text-gray-400 line-through">
                          {formatPrice(parseFloat(product.original_price))}
                        </span>
                      </div>
                    ) : (
                      <div className="mb-3">
                        <span className="text-sm font-semibold">
                          {formatPrice(parseFloat(product.original_price))}
                        </span>
                      </div>
                    )}
                    {/* إخفاء زر أضف للسلة إذا كان المنتج منتهي الكمية */}
                    {(product.is_available === null || product.is_available === undefined || product.is_available === 1 || product.is_available === "1") ? (
                      <button
                        onClick={() => addToCart(product)}
                        className="w-full bg-black text-white py-2 text-sm hover:bg-gray-800 transition-colors"
                      >
                        اضف للحقيبة
                      </button>
                    ) : (
                      <div className="w-full border border-red-300 bg-red-50 py-2 text-sm text-red-700 text-center">
                        انتهت الكمية
                      </div>
                    )}

                    <button
                      onClick={() => removeFavorite(product.id)}
                      className="block mt-2"
                    >
                      <IoTrashOutline className="absolute top-2 left-2 text-lg md:hidden" />
                      <span className="hidden md:block text-xs underline">
                        حذف
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Favorites;
